// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu_root__-M017","fadeIn":"Menu_fadeIn__3NNMD"};